import React from "react";
import PropTypes from "prop-types";

export const SIDEBAR_ICON_SIZE = 18;

const SidebarIconSvg = ({ className, size = SIDEBAR_ICON_SIZE, children }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

SidebarIconSvg.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  children: PropTypes.node.isRequired
};

export default SidebarIconSvg;
